import { render, staticRenderFns } from "./strategy-analytics.vue?vue&type=template&id=0b4a6159&scoped=true&"
import script from "./strategy-analytics.vue?vue&type=script&lang=js&"
export * from "./strategy-analytics.vue?vue&type=script&lang=js&"
import style0 from "./strategy-analytics.vue?vue&type=style&index=0&id=0b4a6159&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a6159",
  null
  
)

export default component.exports